export const passwordRequirementsMessage =
  'Password must be at least 12 characters and include a number, an uppercase letter and a lowercase letter';

export const passwordRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{12,}$/;

export function isPasswordValid(password: string): boolean {
  return passwordRegExp.test(password);
}
